import { render, staticRenderFns } from "./message-face.vue?vue&type=template&id=0ed9e045&scoped=true"
import script from "./message-face.vue?vue&type=script&lang=ts"
export * from "./message-face.vue?vue&type=script&lang=ts"
import style0 from "./message-face.vue?vue&type=style&index=0&id=0ed9e045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed9e045",
  null
  
)

export default component.exports